import { useRef } from 'react'

import shortid from 'shortid'

export function useInstanceId() {
    return useRef<string>(shortid.generate()).current
}
